export default "__VITE_ASSET__CCVuXmYg__"